<div [ngStyle]="{ 'max-width': maxWidth }">
  <ng-container *ngTemplateOutlet="tooltipTemplate; context: { $implicit: data }"></ng-container>
</div>
